import React from 'react';
import { useHistory } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import TopBar from './TopBar';
import BlogAdmin from './BlogAdmin';
import { Helmet } from 'react-helmet';

export default function ContentWriterDashboard() {
  const history = useHistory();
  const { user, profile } = useAuth();

  // Redirect to login if not authenticated or not content writer
  React.useEffect(() => {
    if (!user || profile?.role !== "contentwriter") {
      history.push("/login");
    }
  }, [user, profile, history]);

  if (!user || profile?.role !== "contentwriter") {
    return null;
  }

  return (
    <div>
      <Helmet>
        <title>Content Writer Dashboard - Write Blog</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <BlogAdmin />
    </div>
  );
}



